/**
 * useMembershipResignation — the consumer hook: reads the resignation port from
 * PortsContext, so the surface never imports a concrete adapter (056).
 */

import { useContext } from 'react';

import { PortsContext } from '../providers/PortsContext.js';
import type { MembershipResignationPort } from './MembershipResignationPort.js';

export function useMembershipResignation(): MembershipResignationPort {
  const ports = useContext(PortsContext);
  if (ports === null) {
    throw new Error(
      'useMembershipResignation: PortsContext not found. Make sure the component is wrapped in a PortsProvider.',
    );
  }
  if (ports.membershipResignation === undefined) {
    throw new Error(
      'useMembershipResignation: membershipResignation port is not registered. The resignation step requires it to be configured.',
    );
  }
  return ports.membershipResignation;
}
